export interface Iaccess{
  AplicacionID:number;
  AplicacionName:string;
  Name: string;
  Path: string;
  Icono: string;
  Description: string;
  nombreEstado:string;
  Status: boolean;
  ID: number;
  UserCreation: string;
  DateCreation: string;
  UserLastUpdate: string;
  DateLastUpdate: string;
  StatusName: string;
  ModuleID : number;
}

export class Access implements Iaccess{
      constructor(
      public ID: number,
      public AplicacionID: number,
      public AplicacionName: string,
      public Name: string ,
      public Path: string,
      public Icono:string,
      public Description: string,
      public Status: boolean,
      public nombreEstado :string,
      public UserCreation: string,
      public DateCreation: string,
      public UserLastUpdate: string,
      public DateLastUpdate: string,
      public StatusName: string,
      public ModuleID : number
  ){

      this.ID = ID;
      this.AplicacionID=AplicacionID;
      this.AplicacionName = AplicacionName;
      this.Name=Name;
      this.Path=Path;
      this.Icono=Icono;
      this.Description=Description;
      this.Status=Status;
      this.nombreEstado=nombreEstado;
      this.UserCreation=UserCreation;
      this.DateCreation=DateCreation;
      this.UserLastUpdate=UserLastUpdate;
      this.DateLastUpdate=DateLastUpdate;
      this.StatusName = StatusName;
      this.ModuleID= ModuleID
  }
}
